import { action, ActionType } from "typesafe-actions";
import { FlyerDetailForm } from "../types/flyer-detail-form/flyer-detail-form.interface";
import { IFlyerDetailData } from "../../../types/flyer-detail-data/flyer-detail-data.interface";
import { IError } from "../../../../../redux/actions/errorHandlingAction";
import { Nullable } from "../../../../../types/common";
import { FlyerDetailPageActionType } from "../pages/flyer-detail-page/store/flyer-detail-page.actions";
import { FlyerDetailAddPageActionType } from "../pages/flyer-detail-add-page/store/flyer-detail-add-page.actions";

export enum FlyerDetailActions {
  ClearErrors = "FlyerDetail/ClearErrors",

  CloseConfirmDeleteModal = "FlyerDetail/CloseConfirmDeleteModal",

  Fetch = "FlyerDetail/Fetch",
  FetchFailure = "FlyerDetail/FetchFailure",
  FetchSuccess = "FlyerDetail/FetchSuccess",

  DeletePage = "FlyerDetail/DeletePage",
  DeletePageFailure = "FlyerDetail/DeletePageFailure",
  DeletePageSuccess = "FlyerDetail/DeletePageSuccess",

  ChangeName = "FlyerDetail/ChangeName",

  GoToPage = "FlyerDetail/GoToPage",

  ResetState = "FlyerDetail/ResetState",

  Save = "FlyerDetail/Save",
  SaveFailure = "FlyerDetail/SaveFailure",
  SaveSuccess = "FlyerDetail/SaveSuccess",

  SetFlyer = "FlyerDetail/SetFlyer",

  AddPage = "FlyerDetail/AddPage",
  AddPageSuccess = "FlyerDetail/AddPageSuccess",
  AddPageFailure = "FlyerDetail/AddPageFailure",

  UpdatePermissions = "FlyerDetail/UpdatePermissions",
}

export const clearError = () => action(FlyerDetailActions.ClearErrors);

export const closeConfirmDeleteModal = () => action(FlyerDetailActions.CloseConfirmDeleteModal);

export const fetch = (id: number) => action(FlyerDetailActions.Fetch, id);
export const fetchFailure = (error: Nullable<IError>) =>
  action(FlyerDetailActions.FetchFailure, error);
export const fetchSuccess = (flyer: IFlyerDetailData) =>
  action(FlyerDetailActions.FetchSuccess, flyer);

export const deletePage = (id: number) => action(FlyerDetailActions.DeletePage, id);
export const deletePageFailure = (error: Nullable<IError>) =>
  action(FlyerDetailActions.DeletePageFailure, error);
export const deletePageSuccess = () => action(FlyerDetailActions.DeletePageSuccess);

export const resetState = () => action(FlyerDetailActions.ResetState);

export const changeName = (name: string) => action(FlyerDetailActions.ChangeName, name);

export const save = (form: FlyerDetailForm) => action(FlyerDetailActions.Save, form);
export const saveFailure = (error: Nullable<IError>) =>
  action(FlyerDetailActions.SaveFailure, error);
export const saveSuccess = (flyer: IFlyerDetailData) =>
  action(FlyerDetailActions.SaveSuccess, flyer);

export const setFlyer = (flyer: IFlyerDetailData) => action(FlyerDetailActions.SetFlyer, flyer);

export const addPage = () => action(FlyerDetailActions.AddPage);
export const addPageSuccess = (page: any) => action(FlyerDetailActions.AddPageSuccess, page);
export const addPageFailure = (error: IError) => action(FlyerDetailActions.AddPageFailure, error);

export const goToPage = (pageId: number) => action(FlyerDetailActions.GoToPage, pageId);

export const updatePermissions = (flyer: IFlyerDetailData) =>
  action(FlyerDetailActions.UpdatePermissions, flyer);

const actionCreators = {
  addPage,
  addPageFailure,
  addPageSuccess,
  changeName,
  clearError,
  closeConfirmDeleteModal,
  deletePage,
  deletePageFailure,
  deletePageSuccess,
  fetch,
  fetchFailure,
  fetchSuccess,
  goToPage,
  resetState,
  save,
  saveFailure,
  saveSuccess,
  setFlyer,
  updatePermissions,
};

export type FlyerDetailActionType =
  | ActionType<typeof actionCreators>
  | FlyerDetailPageActionType
  | FlyerDetailAddPageActionType;
